import React from 'react';
export default function StripFullWidthImage(props) {
    var fields = props.fields;
    return (React.createElement("div", { className: 'strip spa-full-width-image' },
        React.createElement("div", { className: "img-container" },
            React.createElement("img", { className: 'img-fluid h-100 w-100', src: fields.image, title: fields.image_title || fields.image_description, alt: fields.alt || fields.image_description }))));
}
